export class StyleManager {
    constructor() {
        this.styleSheet = null;
        this.rules = new Map();
        this.createStyleSheet();
    }

    createStyleSheet() {
        const style = document.createElement('style');
        style.id = 'optimum-styles';
        document.head.appendChild(style);
        this.styleSheet = style.sheet;
    }

    addStyles(styles, namespace = '') {
        if (typeof styles === 'string') {
            // String formatındaki CSS'i ekle
            this.addStringStyles(styles, namespace);
        } else if (typeof styles === 'object') {
            // Object formatındaki CSS'i ekle
            this.addObjectStyles(styles, namespace);
        }
    }

    addStringStyles(styles, namespace) {
        try {
            const ruleIndex = this.styleSheet.insertRule(
                namespace ? `${namespace} { ${styles} }` : styles,
                this.styleSheet.cssRules.length
            );
            this.rules.set(namespace, ruleIndex);
        } catch (error) {
            console.error('Style ekleme hatası:', error);
        }
    }

    addObjectStyles(styles, namespace) {
        Object.entries(styles).forEach(([selector, rules]) => {
            const fullSelector = namespace ?
                (selector === '' ? namespace : `${namespace} ${selector}`) :
                selector;
            this.addRule(fullSelector, rules);
        });
    }

    addRule(selector, rules) {
        if (typeof rules === 'object') {
            const cssRules = this.objectToCssRules(rules);
            try {
                const ruleIndex = this.styleSheet.insertRule(
                    `${selector} { ${cssRules} }`,
                    this.styleSheet.cssRules.length
                );
                this.rules.set(selector, ruleIndex);
            } catch (error) {
                console.error('Rule ekleme hatası:', error, selector, rules);
            }
        }
    }

    objectToCssRules(rules) {
        return Object.entries(rules)
            .map(([prop, value]) => {
                if (typeof value === 'object') {
                    if (prop.startsWith('&')) {
                        return this.objectToCssRules(value);
                    }
                    return `${prop} { ${this.objectToCssRules(value)} }`;
                }
                return `${this.camelToDash(prop)}: ${value};`;
            })
            .join(' ');
    }

    camelToDash(str) {
        return str.replace(/([A-Z])/g, '-$1').toLowerCase();
    }

    removeStyles(namespace) {
        this.rules.forEach((ruleIndex, selector) => {
            if (selector.startsWith(namespace)) {
                try {
                    this.styleSheet.deleteRule(ruleIndex);
                    this.rules.delete(selector);
                } catch (error) {
                    console.error('Style silme hatası:', error);
                }
            }
        });
    }

    clear() {
        try {
            while (this.styleSheet.cssRules.length > 0) {
                this.styleSheet.deleteRule(0);
            }
            this.rules.clear();
        } catch (error) {
            console.error('Stilleri temizleme hatası:', error);
        }
    }
}